<template>
  <transition name="fade" mode="out-in">
    <mallDefault ></mallDefault>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
// store
// mall
import mallDefault from '@/view/wxapp/template/mall/distributor_default'

export default {
  data() {
    return {
      activeIndex: '',
      currentCode: '',
      wxapps: [],
    }
  },
  components: {
    mallDefault: mallDefault,
  },
  computed: {
    ...mapGetters([
      'wxapp_id',
      'template_name'
    ])
  },
  methods: {
    chooseTemp () {
      this.$router.push({path: this.matchInternalRoute('wxapp_templ')})
    }
  },
  mounted () {

    if(this.active){
      this.activeIndex = this.active
    }
    if (this.$route.query.wxappid !== undefined) {
      this.$store.dispatch('setWxappId', this.$route.query.wxappid)
    }
    if (this.$route.query.templatename) {
      this.$store.dispatch('setTemplateName', this.$route.query.templatename)
    }
  }
}
</script>



// WEBPACK FOOTER //
// distributor_template.vue?83b9ea9a